export const SELECT_HIGHSCORE = 'SELECT_HIGHSCORE';
export const REQUEST_HIGHSCORE = 'REQUEST_HIGHSCORE';
export const RECEIVE_HIGHSCORE = 'RECEIVE_HIGHSCORE';
